/* eslint-disable @typescript-eslint/no-explicit-any, eqeqeq  */
import { Radio } from "@/components"
import { useStyles } from "@/components/SelectWithInputs/SelectWithInputs.styles"
import React, { isValidElement, useMemo } from "react"
import { RegisterOptions } from "react-hook-form"

export interface SelectWithInputsProps {
    name: string
    hideLAble?: boolean
    options: {
        key?: string
        controlledInput: {
            props: {
                name: string
                label: string
            }
            [key: string]: any
        }
        [key: string]: any
    }[]
    onChange?: (value: string) => void
    value?: string
    label?: string
    rules?: RegisterOptions
    error?: any
    className?: string | string[]
}

export const SelectWithInputs = (props: SelectWithInputsProps) => {
    const { classes } = useStyles()

    const currentOption = useMemo(() => {
        let result = props.options.find((item) => {
            const key = item?.key ?? item?.controlledInput?.props?.name
            return key === props.value
        })
        if (result?.hideLabel) {
            result = {
                ...result,
                controlledInput: { ...result.controlledInput, props: { ...result.controlledInput.props, label: "" } },
            }
        }
        return result
    }, [props.options, props.value])

    const onChange = (value) => {
        props.onChange(value)
    }

    const renderOptions = () => {
        const result = props.options.map((item) => {
            return (
                <Radio
                    key={item?.key || item.controlledInput?.props.name}
                    label={item.controlledInput?.props.label || item.controlledInput.props.name}
                    value={item?.key || item.controlledInput?.props.name}
                    className={classes.option}
                />
            )
        })
        return result
    }

    return (
        <>
            <Radio.Group
                value={currentOption?.key || currentOption?.controlledInput.props.name}
                name={props.name}
                label={props.label}
                onChange={onChange}
            >
                {renderOptions()}
            </Radio.Group>

            {currentOption?.controlledInput && isValidElement(currentOption.controlledInput) && (
                <div className={classes.container}>
                    {currentOption.controlledInput}
                    {props.error && <div className={classes?.errors}>{props.error}</div>}
                </div>
            )}
        </>
    )
}
